/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum InvoiceMapping {
    COMPANY_NAME = 'company_name',
    UTILITY_NAME = 'utility_name',
    INVOICE_NUMBER = 'invoice_number',
    ACCOUNT_NUMBER = 'account_number',
    UTILITY_COMPANY_ADDRESS = 'utility_company_address',
    SERVICE_ADDRESS = 'service_address',
    INVOICE_DATE = 'invoice_date',
    INVOICE_PERIOD_DATE_RANGE = 'invoice_period_date_range',
    INVOICE_PERIOD_START_DATE = 'invoice_period_start_date',
    INVOICE_PERIOD_END_DATE = 'invoice_period_end_date',
    RESTATEMENT_PERIOD = 'restatement_period',
    SUMMARY_PERIOD = 'summary_period',
    INVOICE_DUE_DATE = 'invoice_due_date',
    INVOICE_TOTAL = 'invoice_total',
    TOTAL_AMOUNT_DUE = 'total_amount_due',
    METER_NUMBER = 'meter_number',
    METER_READ_TYPE = 'meter_read_type',
    METER_READING = 'meter_reading',
    METER_PERIOD_START_DATE = 'meter_period_start_date',
    METER_PERIOD_END_DATE = 'meter_period_end_date',
    METER_COMMODITY = 'meter_commodity',
    METER_USAGE = 'meter_usage',
    UNIT_OF_MEASURE = 'unit_of_measure',
    METER_TOTAL_CHARGES = 'meter_total_charges',
    ADJUSTED_USAGE = 'adjusted_usage',
    METER_CONSUMPTION_CHARGE = 'meter_consumption_charge',
    COMMODITY_SUPPLIER_NAME = 'commodity_supplier_name',
    COMMODITY_DISTRIBUTOR_NAME = 'commodity_distributor_name',
    CONSUMPTION_UNITS = 'consumption_units',
    ADJUSTMENT_FACTOR = 'adjustment_factor',
    MULTIPLIER = 'multiplier',
    POWER_FACTOR = 'power_factor',
    DEMAND_CONSUMPTION = 'demand_consumption',
    DEMAND_CONSUMPTION_UNITS = 'demand_consumption_units',
    RENEWABLE_POWER_CONSUMPTION = 'renewable_power_consumption',
    CAPACITY_CHARGE = 'capacity_charge',
    RATE_RIDER_CHARGE = 'rate_rider_charge',
    RATE_RIDER_CREDIT = 'rate_rider_credit',
    COST_ADJUSTMENT_CREDIT = 'cost_adjustment_credit',
    COST_ADJUSTMENT_CHARGE = 'cost_adjustment_charge',
    WHOLESALE_MARKET_SERVICE_CHARGE = 'wholesale_market_service_charge',
    REGULATORY_CHARGE = 'regulatory_charge',
    STANDARD_SUPPLY_SERVICE_CHARGE = 'standard_supply_service_charge',
    CUSTOMER_CHARGE = 'customer_charge',
    FIXED_CHARGE = 'fixed_charge',
    OTHER_CHARGES = 'other_charges',
    SUPPLY_CHARGE = 'supply_charge',
    RECORD_SUB_TOTAL = 'record_sub_total',
    RENEWABLE_POWER_CHARGE = 'renewable_power_charge',
    ON_PEAK_POWER_CHARGE = 'on_peak_power_charge',
    OFF_PEAK_POWER_CHARGE = 'off_peak_power_charge',
    MID_PEAK_POWER_CHARGE = 'mid_peak_power_charge',
    POWER_FACTOR_CHARGE = 'power_factor_charge',
    BUNDLED_CHARGES = 'bundled_charges',
    TRANSMISSION = 'transmission',
    TRANSPORTATION = 'transportation',
    DISTRIBUTION = 'distribution',
    DELIVERY = 'delivery',
    DEMAND_CHARGE = 'demand_charge',
    DELIVERY_CHARGE_DEMAND_BASED = 'delivery_charge_demand_based',
    PENALTY = 'penalty',
    LATE_FEE = 'late_fee',
    BALANCE_FORWARD = 'balance_forward',
    BALANCE_FORWARD_CREDIT = 'balance_forward_credit',
    CREDITS = 'credits',
    GST = 'gst',
    LOCAL_TAX = 'local_tax',
    FEDERAL_TAX = 'federal_tax',
    HST = 'hst',
    PST = 'pst',
    QST = 'qst',
    CARBON_TAX = 'carbon_tax',
    OTHER_TAX = 'other_tax',
    STATE_TAX = 'state_tax',
}
